import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=eed06a8c&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
